import React, { useState } from "react";
import classNames from "classnames";
import classes from "./TagSnpModalV4.scss";
import UIModal from "UIComponents/UIModal";
import TagSnp from "./TagSnp";

const TagSnpModalV4 = props => {
  const { closeModal, steps } = props;
  const [currentStepIndex, setCurrentStepIndex] = useState(0);

  const currentStep = steps[currentStepIndex];

  const containerClasses = classNames(classes.container, {
    [classes.standardListContainer]: currentStep === "STANDARD_LIST",
  });

  return (
    <UIModal
      onRequestClose={closeModal}
      isOpen={true}
      modalContent={containerClasses}
    >
      <TagSnp
        {...props}
        currentStepIndex={currentStepIndex}
        setCurrentStepIndex={setCurrentStepIndex}
      />
    </UIModal>
  );
};

export default TagSnpModalV4;

TagSnpModalV4.defaultProps = {
  steps: ["CYCLE_LIST", "STANDARD_LIST"],
};
